import { useCallback, useState } from 'react';
import { useSWRFetch } from '@hooks/useSWRFetch';
import { TEN_MINUTES_IN_MS } from '@helpers/constants';
import {
  GetCatalogLatestDataAvailabilityDateRequest__Output,
  GetCatalogLatestDataAvailabilityDateResponse__Output,
} from '@generated/grpc/spotify/catalogexport/v1';

export const useGetCatalogLatestDataAvailabilityDate = (
  request: GetCatalogLatestDataAvailabilityDateRequest__Output,
) => {
  const [exportTypeForRequest, setExportTypeForRequest] =
    useState<GetCatalogLatestDataAvailabilityDateRequest__Output>();

  const shouldRequest =
    request && !!request.exportType && !!exportTypeForRequest;

  const requestObject = {
    url: 'catalog/api/latestdataavailabilitydate',
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
    baseUrl: '',
  };

  const { data, isValidating, isLoading, error, status, mutate } =
    useSWRFetch<GetCatalogLatestDataAvailabilityDateResponse__Output>(
      shouldRequest ? requestObject : null,
      {
        dedupingInterval: TEN_MINUTES_IN_MS,
        shouldRetryOnError: false,
        revalidateOnFocus: false,
      },
    );

  const getData = useCallback(
    (newRequest: GetCatalogLatestDataAvailabilityDateRequest__Output) => {
      setExportTypeForRequest(newRequest);
    },
    [],
  );

  return {
    data,
    isValidating,
    isLoading,
    error,
    status,
    actions: { getData },
    mutate,
  };
};
